import { States } from 'safe'
import {
  CLEAN_DELIVERY_NOTES,
  DeliveryNotesTypes,
  SET_DELIVERY_NOTES,
} from '../actions/actionTypes'

export const initialState: States.DeliveryNotes = {
  deliveryNotes: [],
  numberOfPages: 0,
}

export default (
  state = initialState,
  action: DeliveryNotesTypes
): States.DeliveryNotes => {
  switch (action.type) {
    case SET_DELIVERY_NOTES:
      return {
        deliveryNotes: action.payload.deliveryNotes,
        numberOfPages: action.payload.numberOfPages,
      }
    case CLEAN_DELIVERY_NOTES:
      return {
        deliveryNotes: [],
        numberOfPages: 0,
      }
    default:
      return state
  }
}
